import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import { Autoplay } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let animationId: any = null;
const duration = 4000; // 动画持续时间（毫秒）// 反馈要求改慢一点，文案没看完就走了
let initAniTime = 0; // 开启动画的时间
let aniFrameTime = 0; // 每一帧动画进入时间
const SvgLeft = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">
        <g clipPath="url(#clip0_35_6276)">
            <circle cx="27" cy="27" r="27" transform="matrix(-1 0 0 1 54 0)" fill="#F4F4F4" />
            <path d="M29.25 33.75L22.5 27L29.25 20.25" stroke="black" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_35_6276">
                <rect width="54" height="54" fill="white" transform="matrix(-1 0 0 1 54 0)" />
            </clipPath>
        </defs>
    </svg>
);
const SvgRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">
        <g clipPath="url(#clip0_35_6279)">
            <circle cx="27" cy="27" r="27" fill="#F4F4F4" />
            <path d="M24.75 33.75L31.5 27L24.75 20.25" stroke="black" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_35_6279">
                <rect width="54" height="54" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
const SvgCircle = () => (
    <svg className="circle" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" preserveAspectRatio="none">
        <circle
            cx="18"
            cy="18"
            r="16"
            fill="transparent"
            stroke="#3F68E0"
            strokeWidth="2"
            strokeDashoffset="100"
            strokeLinecap="round"
            strokeDasharray="100 100"
        />
    </svg>
);

export default function B_NA() {
    const { useLang, useEffect, useState, useRouter } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    const [swiper, setSwiper] = useState(null);
    const [active, setActive] = useState(0);

    const cardsDefault: any = [
        {
            img: `/responsive/picture/outdoor-recreation/2_1_na.jpg`,
        },
        {
            img: `/responsive/picture/outdoor-recreation/2_2_na.jpg`,
        },
        {
            img:
                locale === 'za'
                    ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717642893767/2_3_na.png'
                    : `/responsive/picture/outdoor-recreation/2_3_na.jpg`,
        },
        {
            img: `/responsive/picture/outdoor-recreation/2_4_na.jpg`,
        },
        {
            img:
                locale === 'za'
                    ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717578854569/2_5_za.png'
                    : `/responsive/picture/outdoor-recreation/2_5_na.jpg`,
        },
    ];

    const newCardsNA = [
        {
            img: `https://websiteoss.ecoflow.com/upload/image/1747215865494/na1.jpg`,
        },
        {
            img: `https://websiteoss.ecoflow.com/upload/image/1747216212431/na2.jpg`,
        },
        {
            img: `https://websiteoss.ecoflow.com/upload/image/1747216080616/na3.jpg`,
        },
        {
            img: `https://websiteoss.ecoflow.com/upload/image/1754363285055/%E5%A4%A7%E5%9B%BE.jpg`,
        },
        {
            img: `https://websiteoss.ecoflow.com/upload/image/1747729310965/na5.jpg`,
        },
    ];

    const cards = ['us', 'ca'].includes(locale) ? newCardsNA : cardsDefault;

    const lists: any = [
        {
            subtl: t('secB_list1_subtitle'),
            title: t('secB_list1_title'),
            descp: t('secB_list1_desc'),
        },
        {
            subtl: t('secB_list2_subtitle'),
            title: t('secB_list2_title'),
            descp: t('secB_list2_desc'),
        },
        {
            subtl: t('secB_list3_subtitle'),
            title: t('secB_list3_title'),
            descp: t('secB_list3_desc'),
        },
        {
            subtl: t('secB_list4_subtitle'),
            title: t('secB_list4_title'),
            descp: t('secB_list4_desc'),
        },
        {
            subtl: t('secB_list5_subtitle'),
            title: t('secB_list5_title'),
            descp: t('secB_list5_desc'),
        },
    ];

    const handleSlideChange = () => {
        setActive(swiper?.realIndex || 0);
        initAniTime = 0;
        if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
        }
        doAnimate();
    };

    // 执行动画的函数
    const animate = () => {
        const element = document.querySelector('.outdoor-recreation-B .btn .circle circle');
        if (!initAniTime) {
            initAniTime = new Date().getTime();
        }
        aniFrameTime = new Date().getTime();
        // 计算动画进度（0 到 1 之间的值）
        if (element && swiper) {
            const judgeTime = aniFrameTime - initAniTime;
            const progress = Math.min(judgeTime / duration, 1);
            element.style.strokeDashoffset = `${100 - progress * 100}px`;
            if (judgeTime >= duration) {
                swiper.slideNext();
            }
            requestAnimationFrame(animate);
        }
    };

    const doAnimate = () => {
        if (animationId) cancelAnimationFrame(animationId);
        animationId = requestAnimationFrame(animate);
    };

    useEffect(() => {
        const resetGap = () => {
            const winW = window.innerWidth;
            if (winW >= 1440) {
                return setGap(24);
            } else if (winW > 1024) {
                return setGap(20);
            } else {
                return setGap(16);
            }
        };
        resetGap();
        window.addEventListener('resize', resetGap);
        return () => window.removeEventListener('resize', resetGap);
    }, []);

    useEffect(() => {
        if (swiper) {
            // 启动动画
            doAnimate();
        }
    }, [swiper]);

    return (
        <div id="outdoor-recreation-B" className={`outdoor-recreation-B outdoor-recreation-box ${css['outdoor-recreation-B']}`}>
            <div className="inner-box">
                <ul className="text-info">
                    {lists?.map((list: any, k: number) => (
                        <li className={`list-info ${active === k ? 'active' : ''}`} key={k}>
                            <p className="subtitle">{list?.subtl}</p>
                            <h2 className="title">{list?.title}</h2>
                            <p className="desc">{list?.descp}</p>
                        </li>
                    ))}
                    <div className="btns">
                        <span className="btn prev" onClick={() => swiper.slidePrev()}>
                            <SvgLeft />
                        </span>
                        <span className="btn next" onClick={() => swiper.slideNext()}>
                            <SvgRight />
                            <SvgCircle />
                        </span>
                    </div>
                </ul>
                <div className="cards">
                    <Swiper
                        className="swiper-box"
                        modules={[Autoplay]}
                        spaceBetween={gap}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        onSwiper={(swipwerIns: any) => setSwiper(swipwerIns)}
                        loop
                        onSlideChange={handleSlideChange}
                    >
                        {cards?.map((card: any, k: number) => (
                            <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                                {card?.tag && <span className="card-tag">{card?.tag}</span>}
                                <div className="card-img">
                                    <EFPicture src={`${card?.img}`} alt={card?.tag} />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
